<template>
  <v-app>
    <v-app-bar
      app
      height="120"
      :color="offsetTop > 0 ? 'primary' : 'transparent'"
      elevate-on-scroll
      v-if="
        !$router.currentRoute.path.includes('dia-estudiante') &&
        $route.path != '/'
      "
    >
      <v-toolbar-title class="headline text-uppercase">
        <router-link :to="link_inicio">
          <v-img
            v-show="$router.currentRoute.path.includes('primaria')"
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            @click="verifyLevel('Todos')"
            :src="`${publicPath}imagenes/primaria.png`"
          ></v-img>
          <v-img
            v-show="$router.currentRoute.path.includes('preescolar')"
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            @click="verifyLevel('Todos')"
            :src="`${publicPath}imagenes/ciprees.png`"
          ></v-img>
          <v-img
            v-show="$router.currentRoute.path.includes('preparatoria')"
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            @click="verifyLevel('Todos')"
            :src="`${publicPath}imagenes/cuva_pre_osc.png`"
          ></v-img>
          <v-img
            v-show="$router.currentRoute.path.includes('secundaria')"
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            @click="verifyLevel('Todos')"
            :src="`${publicPath}imagenes/logo_secu.png`"
          ></v-img>
          <v-img
            v-show="
              $router.currentRoute.path.includes('eventos') ||
              $router.currentRoute.path.includes('rapaces') ||
              $router.currentRoute.path.includes('ubicacion') ||
              $router.currentRoute.path.includes('informes') ||
              $router.currentRoute.path.includes('inicio') ||
              $router.currentRoute.path.includes('quejas-y-sugerencias') ||
              $router.currentRoute.path.includes('aviso_de_privacidad') ||
              $router.currentRoute.path.includes('national-geographic') ||
              $router.currentRoute.path.includes('inscripciones') ||
              $router.currentRoute.path.includes('dia-v')
            "
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            @click="verifyLevel('Todos')"
            :src="`${publicPath}imagenes/colegio_vizcaya.png`"
          ></v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown && $router.currentRoute.path != '/'"
        @click="drawer = !drawer"
        dark
      ></v-app-bar-nav-icon>
      <v-menu
        offset-y
        class="hidden-sm-and-down"
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="hidden-sm-and-down"
            color="white"
            v-on="on"
            v-if="
              $vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'
            "
          >
            Niveles educativos
            <i class="mdi mdi-menu-down" style="float: right"></i>
          </v-btn>
        </template>
        <v-list class="bg-blue">
          <v-list-item
            v-for="(item, index) in city_options.niveles"
            :key="index"
            class="pa-0 item"
            @click="verifyLevel(item.text)"
          >
            <router-link
              class="py-2 px-5 white--text body-1 custom-link-100"
              :to="item.route"
              >{{ item.text }}</router-link
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        offset-y
        class="hidden-sm-and-down"
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="hidden-sm-and-down"
            color="white"
            v-on="on"
            v-if="
              $vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'
            "
          >
            Vida estudiantil
            <i class="mdi mdi-menu-down" style="float: right"></i>
          </v-btn>
        </template>
        <v-list class="bg-blue">
          <v-list-item
            v-for="(item, index) in vida"
            :key="index"
            class="pa-0 item"
          >
            <router-link
              class="py-2 px-5 white--text body-1 custom-link-100"
              :to="item.route"
              >{{ item.title }}</router-link
            >
          </v-list-item>
          <!--           <v-list-item class="pa-0 item">
            <a
              class="py-2 px-5 white--text body-1 custom-link-100"
              href="https://firebasestorage.googleapis.com/v0/b/universidad-vizcaya.appspot.com/o/documentos%2Freglamentos%2FReglamento%20Institucional%20UVA.pdf?alt=media&token=fe1331c2-4012-46de-a1da-2fe08f498c7e"
              target="_blank"
            >Reglamento institucional</a>
          </v-list-item>
          <v-list-item class="pa-0 item">
            <a
              class="py-2 px-5 white--text body-1 custom-link-100"
              href="https://www.sesweb.mx/"
              target="_blank"
            >SESWEB</a>
          </v-list-item>-->
        </v-list>
      </v-menu>
      <!-- <router-link
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.name !='Welcome'"
        class="hidden-sm-and-down v-btn v-btn--flat v-btn--text theme--light v-size--default white--text link_custom"
        to="/carta-director"
        >Carta del director</router-link
      >-->
      <router-link
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'"
        class="
          hidden-sm-and-down
          v-btn v-btn--flat v-btn--text
          theme--light
          v-size--default
          white--text
          link_custom
        "
        :to="link_location"
        >Ubicación</router-link
      >
      <router-link
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'"
        class="
          hidden-sm-and-down
          v-btn v-btn--flat v-btn--text
          theme--light
          v-size--default
          white--text
          link_custom
        "
        :to="link_information"
        >Informes</router-link
      >
      <a
        v-show="
          $router.currentRoute.path.includes('Colima') ||
          $router.currentRoute.path.includes('Ensenada') ||
          $router.currentRoute.path.includes('Guyamas') ||
          $router.currentRoute.path.includes('Manzanillo') ||
          $router.currentRoute.path.includes('Mexicali') ||
          $router.currentRoute.path.includes('Monclova') ||
          $router.currentRoute.path.includes('Piedras-negras') ||
          $router.currentRoute.path.includes('Ciudad-obregon') ||
          $router.currentRoute.path.includes('Puerto-vallarta') ||
          $router.currentRoute.path.includes('Saltillo') ||
          $router.currentRoute.path.includes('Tepic') ||
          $router.currentRoute.path.includes('Torreon')
        "
        class="
          hidden-sm-and-down
          v-btn v-btn--flat v-btn--text
          theme--light
          v-size--default
          white--text
          link_custom
        "
        :href="'https://uva.edu.mx' + link_inicio"
        >Universidad</a
      >
      <v-menu
        offset-y
        class="hidden-sm-and-down"
        v-if="$vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="hidden-sm-and-down"
            color="white"
            v-on="on"
            v-if="
              $vuetify.breakpoint.lgAndUp && $router.currentRoute.path != '/'
            "
          >
            Quejas y sugerencias
            <i class="mdi mdi-menu-down" style="float: right"></i>
          </v-btn>
        </template>
        <v-list class="bg-blue">
          <v-list-item
            class="pa-0 item"
          >
            <router-link
              class="py-2 px-5 white--text body-1 custom-link-100"
              :to="link_diav"
              >Información</router-link
            >
          </v-list-item>
          <v-list-item
            class="pa-0 item"
          >
            <router-link
              class="py-2 px-5 white--text body-1 custom-link-100"
              :to="'/colaboradores'"
              >Colaboradores</router-link
            >
          </v-list-item>          
        </v-list> 
      </v-menu>     
      <v-menu
        offset-y
        max-height="80vh"
        class="hidden-sm-and-down"
        v-if="
          $router.currentRoute.name != 'Welcome' && $vuetify.breakpoint.lgAndUp
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            dark
            class="hidden-sm-and-down"
            v-on="on"
            v-if="
              $router.currentRoute.name != 'welcome' &&
              $vuetify.breakpoint.lgAndUp
            "
          >
            <span v-if="city_selected != ''">{{ city_options.name }}</span>
            <span v-else>Plantel</span>
            <v-icon color="white">mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list class="bg-blue">
          <v-list-item
            v-for="item in cities"
            class="pa-0 item"
            v-bind:key="item.id"
          >
            <a
              class="py-2 px-5 white--text body-1"
              style="text-decoration: none; width: 100%"
              @click="changeCity(item)"
              >{{ item.name }}</a
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$vuetify.breakpoint.mdAndDown"
    >
      <v-list>
        <v-list-item>
          <h4>{{ this.city_options.name }}</h4>
        </v-list-item>
        <v-list-item @click>
          <router-link
            class="
              py-2
              px-5
              black--text
              text-uppercase
              font-weight-light
              custom-link-100
            "
            to="/"
          >
            Cambiar plantel
            <i class="mdi mdi-chevron-right" style="float: right"></i>
          </router-link>
        </v-list-item>
        <div>
          <v-list-item
            v-for="(item, index) in city_options.niveles"
            :key="index"
            @click="verifyLevel(item.text)"
          >
            <router-link
              class="
                py-2
                px-5
                black--text
                text-uppercase
                font-weight-light
                custom-link-100
              "
              :to="item.route"
              >{{ item.text }}</router-link
            >
          </v-list-item>
        </div>
        <div v-for="(item, index) in items_mobile" :key="index">
          <v-list-group
            v-if="item.children"
            :key="item.title"
            v-model="item.model"
            :append-icon="item.model ? item.icon : item['icon-alt']"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase font-weight-light">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, index) in item.children"
              :key="index"
              class="item"
            >
              <a
                class="py-2 px-5 white--text custom-link-100"
                :href="child.route"
                target="_blank"
                v-if="child.link"
                >{{ child.title }}</a
              >
              <router-link
                class="py-2 px-5 white--text custom-link-100"
                :to="child.route"
                v-else
                >{{ child.title }}</router-link
              >
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.title" @click>
            <router-link
              class="
                py-2
                px-5
                black--text
                text-uppercase
                font-weight-light
                custom-link-100
              "
              :to="item.route"
              >{{ item.title }}</router-link
            >
          </v-list-item>
          <v-divider></v-divider>
        </div>
        <v-list-item
          @click
          v-show="
            $router.currentRoute.path.includes('Colima') ||
            $router.currentRoute.path.includes('Ensenada') ||
            $router.currentRoute.path.includes('Guyamas') ||
            $router.currentRoute.path.includes('Manzanillo') ||
            $router.currentRoute.path.includes('Mexicali') ||
            $router.currentRoute.path.includes('Monclova') ||
            $router.currentRoute.path.includes('Piedras-negras') ||
            $router.currentRoute.path.includes('Ciudad-obregon') ||
            $router.currentRoute.path.includes('Puerto-vallarta') ||
            $router.currentRoute.path.includes('Saltillo') ||
            $router.currentRoute.path.includes('Tepic') ||
            $router.currentRoute.path.includes('Torreon')
          "
        >
          <a
            target="_blank"
            :href="'https://uva.edu.mx' + link_inicio"
            class="py-2 px-5 black--text text-uppercase font-weight-light"
            style="text-decoration: none; width: 100%"
            >Universidad</a
          >
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
    <router-view></router-view>

    <!-- Whatsapp -->
    <v-btn
      v-if="$router.currentRoute.path == ('/')"
      id="social_media_whatsapp"
      fab
      color="#00bb2d"
      href="https://wa.me/523113766390/?text=Hola%20Colegio%20Vizcaya"
      target="_blank"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 155px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
    >
      <v-icon color="white">mdi-whatsapp</v-icon>
    </v-btn>
    <v-btn
      v-if="$router.currentRoute.name == ('inicio_link')"
      id="social_media_whatsapp"
      fab
      color="#00bb2d"
      :href="'https://wa.me/'+city_options.whatsapp+'/?text=Hola%20Vizcaya'"
      target="_blank"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 155px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
    >
      <v-icon color="white">mdi-whatsapp</v-icon>
    </v-btn>
    <v-btn
      v-else-if="$router.currentRoute.name != ('inicio_link') && 
        $router.currentRoute.name != ('preescolar') && 
        $router.currentRoute.path != ('/')"
      id="social_media_whatsapp"
      fab
      color="#00bb2d"
      :href="'https://wa.me/'+city_options.whatsapp+'/?text=Hola%20Vizcaya'"
      target="_blank"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 155px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
    >
      <v-icon color="white">mdi-whatsapp</v-icon>
    </v-btn>
    <v-btn
      v-if="$router.currentRoute.name == ('preescolar')"
      id="social_media_whatsapp"
      fab
      color="#00bb2d"
      :href="'https://wa.me/523112492058/?text=Hola%20Vizcaya'"
      target="_blank"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 155px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
    >
      <v-icon color="white">mdi-whatsapp</v-icon>
    </v-btn>
    <!-- Whatsapp -->

    <!-- Facebook -->
    <v-btn
      v-if="$router.currentRoute.path == ('/')"
      id="social_media_facebook"
      fab
      color="#3b5998"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 15px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
      href="https://www.facebook.com/Colegio-Vizcaya-178827478923600"
      target="_blank"
    >
      <v-icon color="white">mdi-facebook</v-icon>
    </v-btn>
    <v-btn
      v-if="$router.currentRoute.name == ('inicio_link')"
        id="social_media_facebook"
        fab
        color="#3b5998"
        style="
          z-index: 6;
          cursor: pointer;
          position: fixed;
          bottom: 15px;
          right: 20px;
          height: 60px;
          width: 60px;
        "
      :href="city_options.facebook"
      target="_blank"
    >
      <v-icon color="white">mdi-facebook</v-icon>
    </v-btn>
    <v-btn
      v-else-if="$router.currentRoute.name != ('inicio_link') && 
          $router.currentRoute.name != ('preescolar') && 
          $router.currentRoute.path != ('/')"
        id="social_media_facebook"
        fab
        color="#3b5998"
        style="
          z-index: 6;
          cursor: pointer;
          position: fixed;
          bottom: 15px;
          right: 20px;
          height: 60px;
          width: 60px;
        "
      :href="city_options.facebook"
      target="_blank"
    >
      <v-icon color="white">mdi-facebook</v-icon>
    </v-btn>
    <v-btn
      v-if="$router.currentRoute.name == ('preescolar')"
      id="social_media_facebook"
      fab
      color="#3b5998"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 15px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
      href="https://www.facebook.com/CipreesVizcaya"
      target="_blank"
    >
      <v-icon color="white">mdi-facebook</v-icon>
    </v-btn>
    <!-- Facebook -->
    
    <div v-if="!$router.currentRoute.path.includes('dia-estudiante')">
      <v-btn
        v-if="city_options.name == 'Plantel Colima'"
        fab
        color="#D6483C"
        style="
          z-index: 6;
          cursor: pointer;
          position: fixed;
          bottom: 85px;
          right: 20px;
          height: 60px;
          width: 60px;
        "
        href="mailto:direccion_colima@colegiovizcaya.edu.mx"
        target="_blank"
      >
        <v-icon color="white">mdi mdi-email</v-icon>
      </v-btn>
      <v-btn
        v-else
        fab
        color="#D6483C"
        style="
          z-index: 6;
          cursor: pointer;
          position: fixed;
          bottom: 85px;
          right: 20px;
          height: 60px;
          width: 60px;
        "
        href="mailto:informes_primarias@colegiovizcaya.edu.mx"
        target="_blank"
      >
        <v-icon color="white">mdi mdi-email</v-icon>
      </v-btn>
    </div>
    <!--     <v-btn
      v-if="!$router.currentRoute.path.includes('dia-estudiante')"
      id="agend_date"
      fab
      color="#8E0D2C"
      style="z-index: 6;cursor: pointer;position: fixed; bottom: 155px; right: 20px;height: 60px;width: 60px;"
      @click="$store.dispatch('agendDate/modalSend', true)"
      target="_blank"
    >
      <v-icon color="white">mdi-calendar</v-icon>
    </v-btn>  -->
    <v-footer
      color="primary"
      class="font-weight-medium"
      v-if="
        $router.currentRoute.path != '/' &&
        !$router.currentRoute.path.includes('aniversario-vizcaya') &&
        !$router.currentRoute.path.includes('dia-estudiante') &&
        !$router.currentRoute.path.includes('gracias-')
      "
    >
      <v-col
        class="justify-center py-0 align-center d-flex flex-column"
        cols="12"
      >
        <v-img
          height="100"
          width="200"
          contain
          :src="`${publicPath}imagenes/colegio_vizcaya.png`"
        ></v-img>
        <p class="mt-5 white--text" v-if="$router.currentRoute.path.includes('/Tepic/primaria')">
          Calle Infiernillo #57 Col. Electricistas C.P. 63160, Tepic, Nay.
        </p>
        <p class="mt-5 white--text" v-if="$router.currentRoute.path.includes('/Tepic/preescolar')">
          Camino Viejo al Tecolote s/n, esquina con Carrillo Puerto C.P. 63169, Tepic, Nay.
        </p>        
        <p class="mt-5 white--text" v-html="city_options.domicilio" v-if="!$router.currentRoute.path.includes('/Tepic/primaria') && !$router.currentRoute.path.includes('/Tepic/preescolar')"></p>        
        <p
          class="mt-2"
          v-for="(item, index) in city_options.telefonos"
          :key="index"
        >
          <a
            class="white--text"
            style="text-decoration: none"
            :href="'tel:' + item.name"
            >{{ item.name }}</a
          >
        </p>
        <a
          v-if="city_options.name == 'Plantel Tepic'"
          style="text-decoration: none"
          href="mailto:admisiones_ciprees@colegiovizcaya.edu.mx"
          target="_blank"
          class="white--text"
          >admisiones_ciprees@colegiovizcaya.edu.mx</a
        >
        <br />
        <a
          v-if="city_options.name == 'Plantel Tepic'"
          style="text-decoration: none"
          href="mailto:informes_primaria@colegiovizcaya.edu.mx"
          target="_blank"
          class="white--text"
          >informes_primaria@colegiovizcaya.edu.mx</a
        >
        <a
          v-if="city_options.name == 'Plantel Torreón'"
          style="text-decoration: none"
          href="mailto:recepcion_torreon@colegiovizcaya.edu.mx"
          target="_blank"
          class="white--text"
          >recepcion_torreon@colegiovizcaya.edu.mx</a
        >        
        <a
          v-if="city_options.name != 'Plantel Tepic' && city_options.name != 'Plantel Torreón'"
          style="text-decoration: none"
          href="mailto:informes@colegiovizcaya.edu.mx"
          target="_blank"
          class="white--text"
          >informes@colegiovizcaya.edu.mx</a
        >
        <v-row class="py-0" justify="center">
          <v-col cols="12" sm="12">
            <!--<v-img height="100" width="200" contain :src="`${publicPath}imagenes/rapaces.PNG`"></v-img>-->
            <a
              :href="city_options.facebook"
              target="_blank"
              style="text-decoration: none"
              class="mr-3"
            >
              <v-avatar color="white" size="30">
                <v-icon color="grey darken-3">mdi-facebook</v-icon>
              </v-avatar>
            </a>
          </v-col>
        </v-row>
        <router-link :to="'/colaboradores'">
          <v-btn text x-small color="white"> Colaboradores </v-btn>
        </router-link>        
        <router-link :to="link_aviso">
          <v-btn text x-small color="white"> Aviso de privacidad </v-btn>
        </router-link>
        <p class="mt-3 body-2 white--text">Colegio Vizcaya © 2020</p>
      </v-col>
    </v-footer>
    <v-dialog
      v-model="dialog2"
      :fullscreen="$vuetify.breakpoint.lgAndDown"
      max-width="800"
    >
      <v-card color="white" class="py-4" tile>
        <v-card-title class="d-flex flex-column justify-start align-start">
          <h1
            :class="[
              $vuetify.breakpoint.mdAndUp
                ? 'display-3 px-12'
                : 'display-1 px-2',
            ]"
            class="text-uppercase mb-4"
          >
            INSCRÍBETE
          </h1>
          <h3
            class="title word-wrap"
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2']"
          >
            ¡Nosotros nos pondremos en contacto contigo!
          </h3>
        </v-card-title>
        <v-layout
          :row="$vuetify.breakpoint.mdAndUp"
          class="mx-0"
          :column="$vuetify.breakpoint.smAndDown"
        >
          <v-flex
            xs12
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    class="mb-5"
                    label="PRIMER NOMBRE"
                    placeholder="Juan"
                    v-model="information.name_first"
                    type="text"
                    id="name_first"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="SEGUNDO NOMBRE"
                    placeholder="Pérez"
                    v-model="information.name_second"
                    type="text"
                    id="name_second"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="APELLIDO PATERNO"
                    placeholder="López"
                    v-model="information.last_name"
                    type="text"
                    id="lastname"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="APELLIDO MATERNO"
                    placeholder="Garcia"
                    v-model="information.mother_last_name"
                    type="text"
                    id="lastname"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="CORREO ELECTRÓNICO"
                    v-model="information.email"
                    placeholder="correo@ejemplo.com"
                    type="email"
                    id="email"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="NÚMERO TELEFÓNICO"
                    placeholder="(123)-123-1212"
                    v-model="information.phone"
                    type="phone"
                    id="phone"
                  ></v-text-field>
                  <v-text-field
                    class="mb-5"
                    label="LOCALIDAD"
                    v-model="information.localidad"
                    v-mask="'(###)-###-####'"
                    type="phone"
                    id="phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <p class="body-1 text-uppercase">Deseo inscribirme en:</p>
                  <v-select
                    class="mt-8 mb-4"
                    :items="cities2"
                    label="EN EL PLANTEL"
                    hide-details
                    outlined
                    v-model="information.campus"
                    item-value="key"
                  ></v-select>
                  <v-select
                    class="mt-8 mb-4"
                    :items="inscriptionOptions"
                    label="EN LA MODALIDAD"
                    hide-details
                    outlined
                    v-model="information.carrer"
                  ></v-select>
                  <v-textarea
                    label="Mensaje"
                    rows="6"
                    counter="200"
                    no-resize
                    v-model="information.message"
                    id="lastname"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
              >
                <div
                  class="flex-grow-1"
                  v-if="$vuetify.breakpoint.mdAndUp"
                ></div>
                <v-btn rounded text class="px-5" @click="dialog2 = !dialog2"
                  >Cancelar</v-btn
                >
                <v-btn rounded color="primary" class="px-5" @click="submit()"
                  >Enviar formulario</v-btn
                >
              </v-layout>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :right="false">
      {{ snackbarText }}
      <v-btn color="red" dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-dialog v-model="openPopup" max-width="700">
      <v-card class="mx-auto text-center" style="cursor: pointer">
        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'd-flex justify-end'
              : 'd-flex justify-center',
          ]"
        >
          <v-btn
            text
            style="position: absolute; z-index: 1"
            dark
            large
            icon
            @click="$store.dispatch('cities/setModalImagen', false)"
          >
            <v-icon size="x-large">mdi mdi-close</v-icon>
          </v-btn>
        </div>
        <v-carousel cycle :interval="3000" height="auto" hide-delimiters>
          <v-carousel-item v-for="(popup, i) in popups" :key="popup.id">
            <a
              :href="popup.link"
              :target="popup.link_type == 'Externo' ? '_blank' : '_self'"
              ><v-img :src="renderImage(popup.image)"></v-img
            ></a>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <AgendDate />
    <v-snackbar v-model="snackbarAgend.value" :color="snackbarAgend.color" top>
      {{ snackbarAgend.msg }}
      <v-btn
        color="white"
        dark
        text
        @click="
          $store.dispatch('agendDate/setSnackbar', {
            color: '',
            value: false,
            msg: '',
          })
        "
        >Cerrar</v-btn
      >
    </v-snackbar>
  </v-app>
</template>
<style lang="scss">
html,
body {
  overflow-x: hidden !important;
}
@media (max-width: 600px) {
  p {
    text-align: justify !important;
  }
}
.bg-blue {
  background-color: #8e0d2c !important;
}
.item {
  background-color: #8e0d2c;
}
.item:hover {
  background-color: #a01133;
}
.link_custom {
  text-decoration: none;
}
.custom-link-100 {
  text-decoration: none;
  width: 100%;
}
.word-wrap {
  word-break: break-word;
}
.pt-heading {
  padding-top: 120px;
}
.pattern-secondary {
  background-color: #ebe6da;
  background-repeat: repeat;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12' viewBox='0 0 20 12'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='charlie-brown' fill='%23aca9a0' fill-opacity='0.2'%3E%3Cpath d='M9.8 12L0 2.2V.8l10 10 10-10v1.4L10.2 12h-.4zm-4 0L0 6.2V4.8L7.2 12H5.8zm8.4 0L20 6.2V4.8L12.8 12h1.4zM9.8 0l.2.2.2-.2h-.4zm-4 0L10 4.2 14.2 0h-1.4L10 2.8 7.2 0H5.8z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.pattern-primary {
  background-repeat: repeat;
  color: white;
  background-color: #141c3e;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12' viewBox='0 0 20 12'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='charlie-brown' fill='%235071ff' fill-opacity='0.1'%3E%3Cpath d='M9.8 12L0 2.2V.8l10 10 10-10v1.4L10.2 12h-.4zm-4 0L0 6.2V4.8L7.2 12H5.8zm8.4 0L20 6.2V4.8L12.8 12h1.4zM9.8 0l.2.2.2-.2h-.4zm-4 0L10 4.2 14.2 0h-1.4L10 2.8 7.2 0H5.8z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.ocultar {
  display: none;
}
.ql-align-justify {
  text-align: justify;
}
.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
.ql-align-left {
  text-align: left;
}
.contentEditor p,
.contentEditor li {
  margin: 0px !important;
  font-size: 0.99rem;
}
</style>
<script>
import { mapState } from "vuex";
import axios from "axios";
import { mask } from "vue-the-mask";
import lodash from "lodash";
import AgendDate from "@/components/AgendDate.vue";
export default {
  directives: {
    mask,
  },
  name: "App",
  components: {
    AgendDate,
  },
  mounted() {
    this.link();
    this.plantel();
  },
  data: () => ({
    offsetTop: 0,
    publicPath: process.env.BASE_URL,
    niveles: [
      { title: "Preescolar", route: "/preescolar" },
      { title: "Primaria", route: "/primaria" },
      { title: "Secundaria", route: "/secundaria" },
      { title: "Preparatoria", route: "/preparatoria" },
    ],
    inscriptionOptions: [
      "Preescolar",
      "Primaria",
      "Secundaria",
      "Preparatoria",
    ],
    snackbarColor: "",
    snackbarText: "",
    snackbar: false,
    dateValid: false,
    emailValid: false,
    phoneValid: false,
    valid: false,
    dialogVideo: false,
    dialog2: false,
    publicPath: process.env.BASE_URL,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      localidad: "",
      message: "",
      licenciatura: false,
      posgrado: false,
      otros: false,
      escolaridad: "",
      carrer: "",
    },
    dialogInformes: false,
    dialog: false,
    drawer: false,
    city: "",
  }),
  watch: {
    city_options() {
      this.plantel();
    },
  },
  methods: {
    verifyLevel(level) {
      this.$store.dispatch("cities/getFeedDataPhones", {
        level: level,
        campus: this.city_options.link,
      });
    },
    renderImage(image) {
      if (image != null && image != "") {
        if (image.indexOf("https") < 0) {
          return "https://adminuva.tidingo.com/" + image;
        } else {
          return image;
        }
      } else {
        return "";
      }
    },
    changeCity(item) {
      var formData = { link: item.link, isredirect: true };
      this.$store.dispatch("cities/getFeedData", formData);
    },
    link() {
      var linkcampus = "";
      var pathname = window.location.pathname.split("/");
      if (pathname.length > 2) {
        linkcampus = pathname[1];
        if (pathname[2] != "inicio" && pathname[2] != "") {
          linkcampus = pathname[1];
        }
      } else if (pathname[1] == "enamorate-vizcaya") {
        return;
      } else {
        linkcampus = window.location.pathname;
        linkcampus = linkcampus.replace("/", "");
      }
      var formData = { link: linkcampus, isredirect: false };
      this.$store.dispatch("cities/getFeedData", formData);
    },
    plantel() {
      this.city = this.city_selected;
    },
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
    goToHome() {
      if (this.city != "") {
        this.$store.dispatch("cities/setCity", this.city);
        Object.entries(this.campus).forEach(([key, value]) => {
          if (this.city == key) {
            this.$store.dispatch("cities/setCityOptions", value);
          }
        });
        var fromlink = _.find(this.cities, ["key", this.city]);
        _.forEach(this.city_options.niveles, function (value) {
          value.route = "/" + fromlink.title + value.original;
        });
        _.forEach(this.vida, function (value) {
          value.route = "/" + fromlink.title + value.original;
        });
        this.$store.dispatch(
          "cities/setLinkInformation",
          "/" + fromlink.title + "/information"
        );
        this.$store.dispatch(
          "cities/setLinkLocation",
          "/" + fromlink.title + "/location"
        );
        this.$store.dispatch(
          "cities/setLinkInicio",
          "/" + fromlink.title + "/inicio"
        );
        this.$store.dispatch(
          "cities/setLinkAviso",
          "/" + fromlink.title + "/aviso_de_privacidad"
        );
        this.$router.push("/" + fromlink.title + "/inicio/");
      }
    },
    submit() {
      this.validateFields();
      if (this.valid == true) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        this.makeReference();
        this.$router.push("/inscripcion");
        this.dialog2 = !this.dialog2;
      }
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        // this.information.name_second != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.campus != "" &&
        this.information.localidad != "" &&
        this.information.carrer != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar los campos";
        this.snackbar = true;
      }
    },
    makeReference() {
      let state = this.information.campus.toLowerCase();
      if (this.information.name_second != "") {
        this.reference =
          this.information.name_first.toLowerCase() +
          "-" +
          this.information.name_second.toLowerCase() +
          "-" +
          state +
          "-" +
          this.information.carrer.toLowerCase();
        this.$store.dispatch("cities/setReference", this.reference);
      } else {
        this.reference =
          this.information.name_first.toLowerCase() +
          "-" +
          state +
          "-" +
          this.information.carrer.toLowerCase();
        this.$store.dispatch("cities/setReference", this.reference);
      }
    },
  },
  computed: {
    ...mapState({
      snackbarAgend: (state) => state.agendDate.snackbar,
      openPopup: (state) => state.cities.openPopup,
      imagen: (state) => state.cities.imagen,
      popups: (state) => state.cities.popups,
      sliders: (state) => state.cities.sliders,
      campus: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      cities2: (state) => state.cities.cities2,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_aviso: (state) => state.cities.link_aviso,
      link_inicio: (state) => state.cities.link_inicio,
      link_information: (state) => state.cities.link_information,
      link_diav: (state) => state.cities.link_diav,
      link_buenfin: (state) => state.cities.link_buenfin,
      referenceStore: (state) => state.cities.referenceStore,
    }),
    items_mobile() {
      return [
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          title: "Vida estudiantil",
          model: false,
          children: this.vida,
        },
        { route: this.link_location, title: "Ubicación" },
        { route: this.link_information, title: "Informes" },
        { route: this.link_diav, title: "Quejas y sugerencias" },
        { route: '/colaboradores', title: "Colaboradores" },
      ];
    },
  },

  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
